export const aboutData = {
  brandName: '星空传媒',
  brandIntro: '星空传媒成立于2018年，是国内领先的影视内容制作与发行机构。公司秉承"用影像传递温度"的创作理念，致力于打造高品质、多元化的影视作品，涵盖剧情片、纪录片、访谈节目等多个领域。',
  brandStory: `星空传媒的创立源于一群热爱影视艺术的年轻人对优质内容的执着追求。公司创始人陈星宇在影视行业拥有超过十五年的从业经验，深刻理解中国观众对高品质影视内容的渴望。

2018年，陈星宇联合几位志同道合的伙伴，在北京创立了星空传媒。创业初期，公司只有五个人和一间租来的小办公室，但团队对影视创作的热情从未减退。第一部作品《城市微光》虽然成本有限，却凭借真挚的情感和细腻的叙事获得了观众的一致好评，为公司后续发展奠定了坚实基础。

六年来，星空传媒从一个小小的创业团队成长为拥有近百名专业人才的影视制作公司。公司累计制作发行了超过200部影视作品，涵盖剧情、悬疑、动作、爱情、纪录片等多种类型，多部作品获得行业奖项提名。

2023年，星空传媒签约实力派演员香菱，她的加入为公司注入了新的活力。香菱与星空传媒的合作产出了一系列口碑与流量双丰收的优质作品，成为公司发展历程中的重要里程碑。

展望未来，星空传媒将继续坚持"内容为王"的核心理念，加大在原创内容上的投入，同时积极探索新的表现形式和传播渠道，为观众带来更多打动人心的优秀作品。`,
  achievements: [
    { year: '2024', title: '年度最佳影视制作公司', org: '中国影视产业协会' },
    { year: '2024', title: '最受欢迎内容出品方', org: '观众选择奖' },
    { year: '2023', title: '年度创新内容奖', org: '新媒体影视节' },
    { year: '2022', title: '优秀原创内容奖', org: '中国网络视听协会' },
    { year: '2021', title: '行业新锐企业', org: '文化产业峰会' },
    { year: '2020', title: '最具成长力品牌', org: '亚洲影视论坛' },
  ],
  testimonials: [
    {
      name: '影视评论人 周明',
      content: '星空传媒出品的作品始终保持着一贯的高水准，无论是剧本深度还是制作精良程度，都位居行业前列。特别是香菱主演的系列作品，每一部都值得反复品味。',
    },
    {
      name: '资深影迷 李小姐',
      content: '从《深夜的秘密》开始关注星空传媒，一路追到现在，每一部作品都没有让人失望。香菱的演技真的越来越好了，期待更多精彩作品！',
    },
    {
      name: '媒体人 王编辑',
      content: '星空传媒在内容创新和品质把控上的坚持令人钦佩。在流量至上的时代，能够沉下心来做好内容，这份初心难能可贵。',
    },
    {
      name: '忠实观众 张先生',
      content: '星空传媒的作品陪我度过了很多美好时光。每部作品都能感受到制作团队的用心，期待星空传媒越来越好！',
    },
  ],
  contact: {
    email: 'contact@xingkong-media.com',
    phone: '400-888-6688',
    address: '北京市朝阳区建国路88号星空大厦18层',
    wechat: 'xingkong_media',
    weibo: '@星空传媒官方',
    businessHours: '周一至周五 9:00-18:00',
  },
  faqs: [
    {
      question: '星空传媒的作品在哪里可以观看？',
      answer: '星空传媒的作品可在各大主流视频平台观看，包括腾讯视频、爱奇艺、优酷等。部分独家内容仅在星空传媒官方渠道发布，建议关注我们的官方社交媒体获取最新上线信息。',
    },
    {
      question: '如何获取星空传媒最新作品的上线信息？',
      answer: '您可以通过关注星空传媒的官方微博、微信公众号获取最新作品动态。我们会第一时间在这些平台发布新作品的上线时间和观看渠道。',
    },
    {
      question: '香菱2024年一共出演了多少部作品？',
      answer: '香菱在2024年共出演了八部作品，包括五部剧情片、两部专访和一部年度合集，涵盖悬疑、动作、爱情、温情等多种类型，展现了全面的演技实力。',
    },
    {
      question: '星空传媒接受剧本投稿吗？',
      answer: '星空传媒欢迎优秀的原创剧本，您可以将剧本大纲和前三集完整剧本发送至我们的官方邮箱。我们的内容团队会在收到后的15个工作日内进行评审并回复。',
    },
    {
      question: '如何与星空传媒进行商务合作？',
      answer: '商务合作事宜请发送邮件至我们的商务合作邮箱，或在工作时间拨打商务合作热线。我们的商务团队会根据合作类型与您进行详细沟通。',
    },
  ],
};

export const teamMembers = [
  {
    name: '陈星宇',
    role: '创始人 & CEO',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Chinese%20male%20founder%20in%20his%2040s%2C%20confident%20expression%2C%20business%20attire%2C%20warm%20studio%20lighting%2C%20clean%20neutral%20background&width=200&height=200&seq=team-01&orientation=squarish',
  },
  {
    name: '林晓彤',
    role: '内容总监',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Chinese%20female%20executive%20in%20her%2030s%2C%20elegant%20and%20confident%2C%20business%20casual%20style%2C%20warm%20studio%20lighting%2C%20clean%20neutral%20background&width=200&height=200&seq=team-02&orientation=squarish',
  },
  {
    name: '王浩然',
    role: '首席导演',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Chinese%20male%20film%20director%20in%20his%2030s%2C%20artistic%20style%2C%20warm%20studio%20lighting%2C%20clean%20neutral%20background&width=200&height=200&seq=team-03&orientation=squarish',
  },
  {
    name: '赵雪莹',
    role: '市场总监',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Chinese%20female%20marketing%20director%20in%20her%2030s%2C%20friendly%20smile%2C%20modern%20business%20style%2C%20warm%20studio%20lighting%2C%20clean%20neutral%20background&width=200&height=200&seq=team-04&orientation=squarish',
  },
];